module.exports = __webpack_public_path__ + "static/media/phone.4cf27f16.svg";